import ApprovedPatients from './ApprovedPatients';

export default ApprovedPatients;
